var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 150,
    viewBox: "0 0 178 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.409 136.666C177.409 144.035 137.692 150.001 88.7047 150.001C39.7175 150.001 0 144.035 0 136.666C0 129.298 39.7175 123.332 88.7047 123.332C137.692 123.308 177.409 129.298 177.409 136.666Z",
    fill: "#1E01BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.521 -0.000402527L5.01192 46.252L35.8875 137.378L172.396 91.1254L141.521 -0.000402527Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2303 126.54L35.8907 137.379L32.2303 126.54Z",
    fill: "#CDF0B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.734 80.2861L109.716 100.276L100.066 103.556L91.2242 106.551L32.2303 126.54L35.8907 137.378L119.699 108.975L172.394 91.1247L168.734 80.2861Z",
    fill: "#CDF0B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3327 94.1673C94.3141 95.1893 92.1274 97.5662 91.2004 100.371C90.5587 102.32 90.5111 104.459 91.2242 106.551L100.066 103.556L109.74 100.276C108.005 95.1656 102.443 92.4322 97.3327 94.1673Z",
    fill: "#87CD78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.066 103.556L109.716 100.276L100.066 103.556Z",
    fill: "#87CD78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2242 106.551L100.066 103.556L91.2242 106.551Z",
    fill: "#87CD78"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8973 50.2188L50.8412 64.7414L36.3185 69.6853L31.3746 55.1389L45.8973 50.2188ZM45.1367 47.6993L30.4239 52.6907C29.0929 53.1423 28.4036 54.5684 28.8552 55.8995L33.8466 70.6123C34.2982 71.9433 35.7243 72.6326 37.0554 72.181L51.7682 67.1896C53.0992 66.738 53.7885 65.3119 53.3369 63.9808L48.3455 49.268C47.8939 47.9608 46.4678 47.2477 45.1367 47.6993Z",
    fill: "#87CD78"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6172 63.7908C42.1894 63.9334 41.714 63.8859 41.3337 63.6482L35.5104 59.9403C34.8211 59.4887 34.6072 58.5855 35.0588 57.8724C35.5104 57.1831 36.4136 56.9692 37.1267 57.4208L41.1436 59.964C41.9279 56.684 43.877 50.2664 47.9177 44.7521C48.4168 44.0866 49.3438 43.944 50.0093 44.4431C50.6748 44.9422 50.8174 45.8692 50.3183 46.5347C45.1367 53.5703 43.6393 62.5311 43.6155 62.6261C43.5442 63.1253 43.2115 63.5531 42.7598 63.7433C42.7123 63.767 42.6648 63.767 42.6172 63.7908Z",
    fill: "#1E01BE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9056 76.7686L59.8495 91.2912L45.3269 96.2351L40.383 81.7125L54.9056 76.7686ZM54.145 74.2491L39.4322 79.2405C38.1012 79.6921 37.4119 81.1182 37.8635 82.4493L42.8549 97.1621C43.3065 98.4931 44.7326 99.1824 46.0637 98.7308L60.7765 93.7394C62.1075 93.2878 62.7968 91.8617 62.3452 90.5306L57.3538 75.8178C56.9022 74.5106 55.4761 73.7975 54.145 74.2491Z",
    fill: "#87CD78"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M131.365 30.738L64.3943 53.4365L65.8515 57.7362L132.823 35.0377L131.365 30.738Z",
    fill: "#87CD78"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.071 23.9584L76.935 41.6289L78.3922 45.9286L130.528 28.2581L129.071 23.9584Z",
    fill: "#87CD78"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.372 57.2878L73.4004 79.9863L74.8576 84.286L141.829 61.5875L140.372 57.2878Z",
    fill: "#87CD78"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.077 50.5082L85.9411 68.1787L87.3984 72.4784L139.535 54.8079L138.077 50.5082Z",
    fill: "#87CD78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.8ce87d2758e0708136907dc206126778.svg";
export { ForwardRef as ReactComponent };